import axios from "axios";
import { env } from "@/shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

const incidentsClient = axios.create({
  baseURL: env.api.incidents,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(incidentsClient);

export default incidentsClient;
